import { startLegacyRedirect } from './lib/legacy-redirect';

// Importing the app initializes its API/auth providers, so defer it until after the redirect.
if (
	!startLegacyRedirect({
		authOrigin: import.meta.env.VITE_LEGACY_REDIRECT_AUTH_ORIGIN,
		adminOrigin: import.meta.env.VITE_LEGACY_REDIRECT_ADMIN_ORIGIN,
	})
) {
	void import('./bootstrap');
}
